/**
 * DenialSection - Output section for denial information (Drug and Procedure)
 *
 * Displays denial reason, date, and notes.
 */

import { AccordionContent, AccordionItem, AccordionTrigger } from '@components/ui/accordion';
import React from 'react';

import { FieldPathProvider } from '../context';
import { Field, SectionTriggerScore } from './Field';

interface DenialSectionProps {
  data?: Record<string, unknown>;
  sectionId: string;
  entityType?: 'drug' | 'procedure';
}

export const DenialSection: React.FC<DenialSectionProps> = ({
  data,
  sectionId,
  entityType = 'drug',
}) => {
  const label = entityType === 'drug' ? 'Drug' : 'Procedure';

  return (
    <AccordionItem value={sectionId} className="border-b">
      <AccordionTrigger className="px-4 py-3 text-sm font-medium hover:bg-muted/50">
        <div className="flex items-center gap-2 flex-1">
          <span>{label} Denial</span>
          <SectionTriggerScore subsectionKey="denial" />
        </div>
      </AccordionTrigger>
      <AccordionContent className="px-4 pb-4">
        <FieldPathProvider prefix={`${entityType}.denial`}>
          <div className="grid grid-cols-2 gap-x-4 gap-y-1">
            <Field
              label="Denial Date"
              value={data?.prior_authorization_denial_date}
              fieldId="prior_authorization_denial_date"
            />
            <Field
              label="Denial Reference"
              value={data?.prior_authorization_denial_reference}
              fieldId="prior_authorization_denial_reference"
            />
            <div className="col-span-2">
              <Field
                label="Denial Reason"
                value={data?.prior_authorization_denial_reason}
                fieldId="prior_authorization_denial_reason"
              />
            </div>
          </div>
        </FieldPathProvider>
      </AccordionContent>
    </AccordionItem>
  );
};
